import React from "react";
import T from "prop-types";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import { withPolling } from "MODULES/shared/decorators";
import {
  SalesCount,
  SaleLinesCount,
  SalesSumProjection,
  SalesProfit,
  SalesPercentProfit,
  SalesPercentGoal,
  SalesSumProjectionNA,
  GrossSalesSum
} from "./Stats";

function QuarterlyStats({ selectedDate, salesData }) {
  const date = "QTD";
  const endOfQuarter = moment(selectedDate)
    .endOf("quarter")
    .toDate();
  const completedQuarter = endOfQuarter < new Date();

  return (
    <Row>
      <Col md={1} mdOffset={1}>
        <SalesCount dateLabel={date} data={salesData} />
      </Col>
      <Col md={1}>
        <SaleLinesCount dateLabel={date} data={salesData} />
      </Col>
      <Col md={1}>
        <GrossSalesSum dateLabel={date} data={salesData} period="quarterly" />
      </Col>
      <Col md={2}>
        <SalesProfit dateLabel={date} data={salesData} />
      </Col>
      <Col md={2}>
        {!completedQuarter && (
          <SalesSumProjection dateLabel={date} data={salesData} />
        )}
        {completedQuarter && <SalesSumProjectionNA dateLabel={date} />}
      </Col>

      <Col md={2}>
        <SalesPercentProfit dateLabel={date} data={salesData} />
      </Col>
      <Col md={1}>
        <SalesPercentGoal dateLabel={date} data={salesData} />
      </Col>
    </Row>
  );
}

QuarterlyStats.propTypes = {
  selectedDate: T.string,
  salesData: T.arrayOf(T.shape({}))
};

export default withPolling(QuarterlyStats);



// WEBPACK FOOTER //
// ./app/modules/SalesDashboard/Components/QuarterlyStats.jsx